import { cn } from '@client/lib/utils';
import { hapticMedium, hapticLight } from '@client/lib/haptics';
import { Camera } from 'lucide-react';
import type { Task } from '@shared/types';

interface TaskCardProps {
  task: Task;
  onComplete: () => void;
  onSkip: () => void;
  loading?: boolean;
}

export function TaskCard({ task, onComplete, onSkip, loading }: TaskCardProps) {
  const handleComplete = () => {
    hapticMedium();
    onComplete();
  };

  const handleSkip = () => {
    hapticLight();
    onSkip();
  };

  return (
    <div className="mx-4">
      <div className="bg-card rounded-2xl p-6 shadow-sm">
        <p className="text-[13px] leading-[18px] font-bold text-primary text-center mb-3">
          Sabrina & Stefan · Foto-Mission
        </p>

        {/* Task icon */}
        <div className="relative w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
          <Camera className="w-8 h-8 text-primary" />
          <span className="absolute -right-1 -top-1 flex h-6 w-6 items-center justify-center rounded-full bg-primary text-[13px] leading-none text-primary-foreground">
            ✨
          </span>
        </div>

        {/* Task description */}
        <p className="text-[15px] leading-[20px] text-muted-foreground text-center mb-2">
          Deine Mission
        </p>
        <h2 className="text-[22px] leading-[28px] font-bold text-center mb-6">
          {task.description}
        </h2>

        {/* Actions */}
        <div className="flex flex-col gap-3">
          <button
            onClick={handleComplete}
            disabled={loading}
            className={cn(
              'w-full py-3.5 bg-primary text-primary-foreground rounded-[14px]',
              'text-[17px] leading-[22px] font-semibold ios-pressable',
              'disabled:opacity-50'
            )}
          >
            Foto machen
          </button>
          <button
            onClick={handleSkip}
            disabled={loading}
            className={cn(
              'w-full py-3.5 text-primary',
              'text-[17px] leading-[22px] font-medium ios-tap',
              'disabled:opacity-50'
            )}
          >
            Neue Mission
          </button>
        </div>
      </div>

    </div>
  );
}
